// import Swiper JS
import { Swiper, Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

import '../../../src/docReady.js';
import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js'; // easing
import './style.scss';

const moduleSelector = '.eiovisual-gallery1';

/**
 * Classe esempio
 */
class Module {

    // _________________________________________________________________________

    constructor() {
        this.run();

        Helper.debug('Modulo gallery1');

        console.log('gall1')
    }

    // _________________________________________________________________________

    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {
    
    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        // Run tasks
        setTimeout(() => { this.task1() },4000);
    }
    
    /**
     * Arriva da sx
     * @returns {undefined}
     */
    task1() {

        const swiper = new Swiper( this.$module.querySelector('.gallery'), {
            // configure Swiper to use modules
            modules: [Navigation, Pagination],

            loop: true,

            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },

            slidesPerView: 1,
            spaceBetween: 20,

            breakpoints: {
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
                1280: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                  },
            },

            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

        });
        
    }

}

// export
export default new Module();